/*
Item: Save Dialog component for creating saving tables from Statistics.jsx
Name: SaveDialog
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MultiLanguage } from '../../utils/MultiLanguage';
import MessageService from '../../service/MessageService';
import NodeService from '../../service/NodeService';
import { CategoryEnums, StatisticNumbers } from '../../utils/statisticsUtils';
import { InputTextarea } from 'primereact/inputtextarea';

export default class SaveTableDialog extends Component {
  constructor(props) {
    super(props);
    const {
      tableName, onHideSaveTable, abortOverride, saveTable, overrideTable
    } = this.props;
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
    this.onHideSaveTable = onHideSaveTable;
    this.onFolderTreeExpand = this.onFolderTreeExpand.bind(this)
    this.abortOverride = abortOverride;
    this.saveTable = saveTable;
    this.overrideTable = overrideTable;
    this.role = sessionStorage.getItem('role');
    this.group = sessionStorage.getItem('group');
    this.state = {
      // allNodes: [],
      tableName: tableName || '',
      maxLength: 180,

      folders: [
        { key: '0', data: { foldername: 'Persönlicher Ordner', rightArea: 'BEN', isSelected: true } },
        { key: '1', data: { foldername: 'Gruppenordner', rightArea: 'GRP' } }
      ]
    };
    this.nodeservice = new NodeService();
  }

  sliceTableCaption(caption, maxLength) {
    if(caption.length > maxLength) {
      while(caption.length > maxLength -3) {
        caption = caption.slice(0, caption.lastIndexOf(", "))
      }
      return caption + "...";
    }
    return caption
  }

  componentDidMount = async () => {
    const structureInit = await this.messageService.postStructureInit();
    let maxLength = structureInit?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.attributeLength?.TITLE || 180 

    const { role } = this;
    const { folders } = this.state;
  
    if (role === 'INTERNAL_USER' && this.group === 'StBA') {
      folders.push({ key: '2', data: { foldername: 'Amtsinterner Ordner', rightArea: 'OFFICE' } }); // Fix Ticket 500, was 'FREE'
    }
    if (role === 'GROUP_ADMIN' && this.group === 'StBA') {
      folders.push({ key: '2', data: { foldername: 'Amtsinterner Ordner', rightArea: 'OFFICE' } }); // Fix Ticket 500, was 'FREE'
      folders.push({ key: '3', data: { foldername: 'Öffentlicher Ordner', rightArea: 'FREE' } });
    }
    if (role === 'SYSTEM_ADMIN' || role === 'SUPER_SUBJECT_ADMIN') {
      folders.push({ key: '2', data: { foldername: 'Amtsinterner Ordner', rightArea: 'OFFICE' } }); // Fix Ticket 1825, was 'FREE'
      folders.push({ key: '3', data: { foldername: 'Öffentlicher Ordner', rightArea: 'FREE' } });
    }

    const results = await Promise.all([
      ...folders.map((folder) => this.getDirectory('folder', folder.data.rightArea, '190', 'FOLDER', folder.key, [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'FOLDER',
          name: null,
          reference: null,
          id: -1,
      }
      ]))
    ])

    folders.forEach((folder, i) => {
      results[i].forEach((result) => {
        result.data.foldername = result.data.name
        result.data.rightArea = folder.data.rightArea
        if(result.data.folderCount > 0) result.leaf = false
      })
      folder.children = results[i];
    })
    this.setState({folders, maxLength})
  }

  async onFolderTreeExpand(e) {
    const { folders } = this.state;
    if(e.node.data.folderCount > 0) {
      const subFolders = await this.getDirectory('folder', e.node.data.rightArea, '190', 'FOLDER', e.node.key, [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'FOLDER',
          name: null,
          reference: null,
          id: e.node.data.id,
      }
      ])

      subFolders.forEach((result) => {
        result.data.foldername = result.data.name
        result.data.rightArea = e.node.data.rightArea
        if(result.data.folderCount > 0) result.leaf = false
      })
      
      e.node.children = subFolders
    }
   this.setState({folders})
  }


  /* Highlight if folder preselected?
  rowClassName() {
    return { 'p-highlight': this.folderPreSelected };
  }
  */

  async getAllNodes() {
    await this.nodeservice.getTreeTableNodes('../assets/treetablenodesall.json').then((data) => this.setState({ allNodes: data }));
    // console.log('cdm1b', this.state.nodes);
    const right = 'ALL';
    const type = 'ordercriterion';
    const objectTyp = 'ORDERCRITERION';
    const objectNumber = '109'; // STRUCTURE=108
    const prefix = '0';
    // console.log('componentDidMount1', type, right, objectNumber, objectTyp, prefix);
    const children2 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix);
    // console.log('componentDidMount12');
    const { allNodes } = this.state;
    // über alle in children
    for (let i = 0; i < children2.length; i += 1) {
      const { name } = children2[i].data;
      const statistic = StatisticNumbers[children2[i].data.statisticName];
      const category = CategoryEnums[children2[i].data.reference.topicType];
      const subCategory = allNodes[statistic].children[category].children.length;
      const insertItem = {
        key: '0-0-0',
        data: {
          name: '', id: 0, statistic: 0, category: 0,
        },
        category: 'Standardtabelle',
        selectable: true,
      };
      const key = `${statistic}-${category}-${subCategory}`;
      insertItem.key = key;
      insertItem.data.id = children2[i].data.id;
      insertItem.data.name = name;
      // console.log('#NAME', name, `${statistic}-${category}-${subCategory}`);
      insertItem.data.reference = children2[i];
      allNodes[statistic].children[category].children[subCategory] = insertItem;
    }
    // this.setState({ allNodes });
    return allNodes;
  }

  async getDirectory(type, right, objectNumber, objectTyp, prefix, links = []) {
    const typeString = 'Standard';
    const elementsData1 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, typeString, false, links);
    let children = [];
    if (elementsData1[0]) {
      if(elementsData1[2] !== 104) this.growl.show({ severity: elementsData1[1], summary: 'Hinweis', detail: elementsData1[0] });
    } else {
      const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      children = entries.map((entry, i) => (
        {
          key: `${prefix}-${i}`,
          type,
          objectNumber,
          leaf: true,
          data: {
            name: entry.name,
            date: entry.modifiedTime,
            statisticName: entry.statisticName,
            id: entry.id,
            reference: entry,
            structureCount: entry.structureCount,
            folderCount: entry.folderCount
          },
        }
      ));
    }
    return children;
  }

  async doCheck(e) {
    // load allNodes if not already done
    let { allNodes } = this.state;
    if (!allNodes) {
      allNodes = await this.getAllNodes();
    }
    this.setState({ allNodes, selectedFolder: undefined, checked: e.checked });
  }

  showOverrideMessage() {
    const { saveTableOverrideMessage } = this.props;
    return (
      <div className="card" style={{ backgroundColor: '#2196F3', borderColor: '#2196F3' }}>
        <span style={{ color: '#ffffff' }}>
          {saveTableOverrideMessage}
        </span>
      </div>
    );
  }

  



  renderFooter() {
    const {
      tableName, selectedFolderKey, checked, allNodes, selectedFolder, maxLength
    } = this.state;
    const { saveTableOverrideMessage, tableDescription } = this.props;
    const shortTableDescription = this.sliceTableCaption(tableDescription, maxLength);
    const standardTable = checked ? 'DEFAULT' : '';
    let orderCriterionId;
    let orderCriterionReference;
    // TODO Hier muss entweder in folders oder in allNodes gesucht werden:
    let rightArea = '';
    if (selectedFolder) {
      if (checked) {
        rightArea = 'BEN'; // Default
        const arrSel = selectedFolder.key.split('-');
        orderCriterionId = allNodes[arrSel[0]].children[arrSel[1]].children[arrSel[2]].data.id;
        orderCriterionReference = allNodes[arrSel[0]]
          .children[arrSel[1]].children[arrSel[2]].data.reference;
      }
      else{
        rightArea = selectedFolder.data.rightArea;
      }
      // console.log('STRUCTURE#0', rightArea);
    }

    return (
      <div>
        <Button
          label={saveTableOverrideMessage ? 'Ja' : 'Speichern'}
          id="save"
          type="button"
          icon="pi pi-check"
          disabled={!(tableName && selectedFolder)}
          onClick={saveTableOverrideMessage
            ? () => {
              this.overrideTable(tableName,
                rightArea, standardTable, orderCriterionId, orderCriterionReference);
            } : () => {
              this.saveTable(tableName,
                rightArea, standardTable, orderCriterionId, orderCriterionReference, shortTableDescription, selectedFolder);
            }}
        />
        <Button
          label={saveTableOverrideMessage ? 'Nein' : 'Abbrechen'}
          id="abortSave"
          type="button"
          icon="pi pi-times"
          onClick={
            saveTableOverrideMessage
              ? () => { this.abortOverride(); }
              : () => { this.onHideSaveTable(); }
          }
          className="p-button-danger"
        />
      </div>
    );
  }

  render() {
    const {
      checked, tableName, selectedFolder, allNodes, visible, maxLength
    } = this.state;
    const { saveTableVisible, saveTableOverrideMessage, tableDescription } = this.props;
    const shortTableDescription = this.sliceTableCaption(tableDescription, maxLength);
    const styleVar = { height: '380px', overflowY: 'scroll' };
    const styleFix = { height: '280px' };
    const role = sessionStorage.getItem('role');
    const isAdmin = (role === 'GROUP_ADMIN' || role === 'SYSTEM_ADMIN' || role === 'SUPER_SUBJECT_ADMIN');
    const isStBA = sessionStorage.getItem('group') === 'StBA';
    return (
      <div>
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog
          header="Aktualisiere Ansicht..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          header="Tabelle speichern"
          visible={saveTableVisible}
          style={{ width: '50vw' }}
          footer={this.renderFooter()}
          onHide={this.onHideSaveTable}
          modal
        >
          <div
            style={styleVar }
            className="card"
          >
            <div className="p-grid p-fluid">
              <div className="p-col-12">
                <div className="box">
                  <TreeTable
                    lazy={true}
                    value={checked ? allNodes : this.state.folders}
                    selectionMode="single"
                    selectionKeys={selectedFolder?.key}
                    onSelect={(e) => this.setState({ selectedFolder: e.node })}
                    onExpand={this.onFolderTreeExpand}
                  >
                    <Column
                      field={checked ? 'name' : 'foldername'}
                      header={checked ? 'Standardordner*' : 'Ordnerverzeichnis*'}
                      expander
                    />
                  </TreeTable>
                  <p />
                </div>
              </div>
              <div className="p-col-8">
                <span className="md-inputfield">
                  <InputText
                    disabled={saveTableOverrideMessage}
                    maxLength="99"
                    id="tableName"
                    value={tableName || ''}
                    onChange={(e) => this.setState({ tableName: e.target.value })}
                  />
                  <label htmlFor="tableName">Tabellenname*</label>
                </span>
              </div>
              <div className="p-col-4">
                {isAdmin && isStBA
                  ? (
                    <div className="box">
                      <Checkbox
                        inputId="checkbox"
                        value="DEFAULT"
                        onChange={(e) => this.doCheck(e)}
                        checked={checked}
                      />
                      <label htmlFor="checkbox" className="p-checkbox-label">Standardtabelle</label>
                    </div>
                  )
                  : <div />}
              </div>
              <div className="p-col-12">
                <span>Beschreibung (Merkmale):</span>
              </div>
              <div className="p-col-12">
                  <InputTextarea
                    disabled={true}
                    id="tableDescription"
                    value={shortTableDescription || ''}
                    autoResize={true}
                  />
              </div>
            </div>
          </div>
          {saveTableOverrideMessage ? this.showOverrideMessage() : ''}
        </Dialog>
      </div>
    );
  }
}
